import {
  useMutation,
  useQueryClient,
  UseMutationResult,
} from "@tanstack/react-query";

import {
  CreateLiveReportLinkInput,
  LiveReportLink,
} from "../../models/live-report";
import { createManagedLiveReportLink } from "../../client/manager/live-report";
import { managedLiveReportLinksQueryKey } from "./useManagedLiveReportLinks";
import { useTixologiTokenRefresher } from "./useTixologiTokenRefresher";

export function useCreateManagedLiveReportLink(
  partnerId: string | undefined,
  isComedian = false
): UseMutationResult<LiveReportLink, Error, CreateLiveReportLinkInput> {
  const queryClient = useQueryClient();
  const { token, refresh } = useTixologiTokenRefresher(partnerId, isComedian);

  return useMutation({
    mutationFn: async (input: CreateLiveReportLinkInput) => {
      const initial = token ?? (await refresh());
      if (!initial) throw new Error("Tixologi token not available");
      return createManagedLiveReportLink(initial, input, refresh);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: managedLiveReportLinksQueryKey(partnerId),
      });
    },
  });
}
